import { render, staticRenderFns } from "./CommentData.vue?vue&type=template&id=04603919&scoped=true"
import script from "./CommentData.vue?vue&type=script&lang=js"
export * from "./CommentData.vue?vue&type=script&lang=js"
import style0 from "./CommentData.vue?vue&type=style&index=0&id=04603919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04603919",
  null
  
)

export default component.exports